import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';

import { parseStringOr } from '../../helpers/AppxUtils';
import { TvPlanContext } from '../../contexts/tvplancontext';
import ErrorMessage from '../ErrorMessage';
import TvService from '../TvService';
import Price from '../Price';
import AddButton from '../AddButton';
import RemoveButton from '../RemoveButton';

import './index.css';


function TvPlanPack (props) {
    const { t, i18n }  = useTranslation('tvplan');
    const ctx = useContext(TvPlanContext)
    const code = props.code;
    const cfg = ctx.getTvConfig();
    const fav = cfg.favs[code] || {};
    const services = fav.services || [];
    let des = parseStringOr(fav.des, "");
    let desFr = parseStringOr(fav.desFr, "");

    if (i18n.language === "fr" && desFr !== "") {
        des = desFr;
    }

    if (typeof fav !== "object") {
        return (
            <ErrorMessage>{t('Pack not found')} :{code}</ErrorMessage>
        );
    }

    let checkCode = null;
    let packClass = "tv-channel-pack";
    let actionButton =  (<AddButton onClick={props.onSelect} code={code} type="fav" />);

    if (props.selected) {
        packClass += " selected";
        checkCode = (<div className="tv-plan-pack-check"><FontAwesomeIcon icon={faCheckCircle} /></div>);
        actionButton = (<RemoveButton onClick={props.onSelect} code={code} type="fav" />);
    }

    return (
        <div className={packClass} data-apiCode={code}>
            <div className="tv-channel-pack-name">{des}</div>
            {services.length > 0 && services.map(s => (
            <TvService
                key={`key-fav-${code}-${s}`}
                showSelected={props.showSelected}
                removeIfInStarter={true}
                code={s}
                onClick={props.onClick} />
            ))}
            <div className="tv-pack-bottom">
                <div className="tv-pack-price"><Price>{fav.price}</Price></div>
                {actionButton}
            </div>
            {checkCode}
        </div>
    );
}

export default TvPlanPack;
